import React from "react";
import PropTypes from "prop-types";

function Select({
    label,
    optionList, 
    disabled,
    onChange,
    value,
    className,
    firstOption,
    errorMessage
}) {
    
    return (
        <>
      
        <div className={className}>
            {label && (
                <label htmlFor="exampleFormControlSelect1" className="form-label">
                    {label} {errorMessage &&<span style={{color:"red"}}>*</span>}
                </label>
            )}
            <select
                className={`form-control  ${errorMessage ? 'is-invalid validation_error_background' : ''} ${value ? 'is-valid' : ''}`}
                
                id="exampleFormControlSelect1"
                value={value}
                onChange={onChange}
                disabled={disabled}
            >
                {firstOption && <option value={""} disabled>{firstOption}</option>}
                {optionList.map((state, index) => (
                    <option key={index} value={state.value || state}>{state.label || state}</option>
                ))}
            </select>
            {errorMessage && <div className='validation_error pl-1'>{errorMessage}</div>}
        </div>
       
        </>
    );
}
Select.propTypes = {
    label: PropTypes.string,
    optionList: PropTypes.array,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
    keyValueSame: PropTypes.bool,
    firstOption: PropTypes.string,
    selectClassName: PropTypes.string
};
export default Select;
